import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Grid, Typography } from '@mui/material';
import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

var links = [
    {
        name: "UP CURSOR Website",
        link: "https://www.upcursor.com/"
    },
    {
        name: "UP CURSOR FB Page",
        link: "https://www.facebook.com/UPCURSOR"
    },
    {
        name: "UP ACM Website",
        link: "https://upacm.net/"
    },
    {
        name: "UP ACM FB Page",
        link: "https://www.facebook.com/upacm/"
    },
    {
        name: "UP CSI FB Page",
        link: "https://www.facebook.com/upcsi/"
    },
]

function Org() {
    const cardStyle = { width: 1, height: "100%", boxShadow: 5 };
    return(
        <ThemeProvider theme={theme}>
        <NavbarDefault />
            <Grid         
                container
                direction="row"
                justifyContent="center"
                height="50%"
                sx={{ flexGrow: 1, 
                paddingBottom: 2,
                paddingRight: 2,
                marginTop: 2,
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 5,
                maxWidth: 1,
                alignItems: "center"
                }}
                spacing={2}
            >
                <Grid item xs={8} sx={{textAlign: 'justify'}}>
                    <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                        DCS STUDENT ORGANIZATIONS 
                    </Typography>
                </Grid>
                {links.map((org) => (
                    <Grid item xs={8}>
                        <Card sx={cardStyle}>
                            <CardActionArea href={org.link} style={{textDecoration: 'none'}} sx={{":hover": {color:"black"}}}>
                                <CardContent>
                                <ThemeProvider theme={theme}>
                                    <Typography gutterBottom variant="h6" component="div" marginLeft={1} marginRight={1} marginBottom={0}>
                                    <b>{org.name}</b>
                                    </Typography>
                                </ThemeProvider>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>))}
            </Grid>
        <FooterDefault /> 
        </ThemeProvider>
    )
}

export default Org